import React, { useState } from 'react';
import { useSyles } from './styles';
import { Hidden } from '@material-ui/core';
import Header from '../Header';
import Menu from '../Menu';
import BarcodeReader from 'react-barcode-reader';
import useScan from '../../../hooks/useScan';

const Layout = ({ children }) => {
  const classes = useSyles();
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = () => setOpenMenu(!openMenu);

  const { handleScan, handleError } = useScan();

  return (
    <div className={classes.layout}>
      <Header onOpenMenu={handleOpenMenu} />
      <Hidden smDown>
        <Menu variant='permanent' open={true} />
      </Hidden>
      <Menu variant='temporary' open={openMenu} onClose={handleOpenMenu} />
      <main className={classes.main}>{children}</main>
      <BarcodeReader onError={handleError} onScan={handleScan} minLength={3} />
    </div>
  );
};

export default Layout;
